import ajax from '../services/ajax';

export default () => {
    return ajax('/__/api/v1/hi', {
        dataType: 'jsonp'
    });
};
